<template>
  <UApp>
    <div class="min-h-screen flex flex-col justify-between">
      <div>
        <NuxtLoadingIndicator/>
        <div class="flex justify-between m-5">
          <Logo />
          <slot name="title">
            <ShopTitle/>
          </slot>
          <Toolbar/>
        </div>

        <slot name="bio"></slot>

        <slot name="categories">
          <Categories/>
        </slot>

        <div class="mx-5">
          <slot/>
        </div>

      </div>
      <div>
        <Footer/>
      </div>
    </div>
  </UApp>
</template>

<script lang="ts" setup>
const nuxtApp = useNuxtApp();
const loading = ref(false);
nuxtApp.hook("page:start", () => {
  loading.value = true;
});
nuxtApp.hook("page:finish", () => {
  loading.value = false;
});


</script>

<style lang="scss" scoped>
</style>